/* Expand/collapse long product descriptions without deleting or cutting off HTML. */
(() => {
  'use strict';
  function initialize(root) {
    if (root.dataset.abdDescriptionReady === 'true') return;
    const content = root.querySelector('[data-abd-description-content]');
    const toggle = root.querySelector('[data-abd-description-toggle]');
    const label = toggle && toggle.querySelector('[data-abd-description-toggle-text]');
    if (!content || !toggle || !label) return;
    root.dataset.abdDescriptionReady = 'true';
    let expanded = false;
    function update() {
      // Temporarily expand to measure actual rich-text content height.
      content.removeAttribute('data-abd-collapsed');
      const style = getComputedStyle(content);
      const line = Number.parseFloat(style.lineHeight);
      const fontSize = Number.parseFloat(style.fontSize) || 16;
      const lineHeight = Number.isFinite(line) ? line : fontSize * 1.65;
      const count = Math.max(3, Math.min(15, Number(root.dataset.lines) || 7));
      const previewHeight = Math.round(lineHeight * count);
      content.style.setProperty('--abd-description-height', previewHeight + 'px');
      const overflowing = content.scrollHeight > previewHeight + 12;
      toggle.hidden = !overflowing;
      if (!overflowing) expanded = false;
      if (overflowing && !expanded) content.setAttribute('data-abd-collapsed', 'true');
      toggle.setAttribute('aria-expanded', String(overflowing && expanded));
      label.textContent = expanded ? (toggle.dataset.lessLabel || 'Show less') : (toggle.dataset.moreLabel || 'Show more');
    }
    toggle.addEventListener('click', () => {
      expanded = !expanded;
      update();
    });
    // Re-evaluate on responsive changes and after embedded images finish loading.
    let resizeQueued = false;
    window.addEventListener('resize', () => {
      if (!resizeQueued) {
        resizeQueued = true;
        requestAnimationFrame(() => { resizeQueued = false; update(); });
      }
    }, {passive:true});
    content.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', update, {once:true});
    });
    update();
  }
  function scan() { document.querySelectorAll('[data-abd-description]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
